
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lib/type/audio",
      function () {
        return require("private-next-pages/lib/type/audio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lib/type/audio"])
      });
    }
  